import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  FiChevronRight,
  FiShoppingBag,
  FiTruck,
  FiGlobe,
  FiMail,
  FiCreditCard,
  FiAlertTriangle,
  FiPhone,
} from 'react-icons/fi';
import { PiBankBold } from 'react-icons/pi';
import '../../styles/categoryPage.css';
import './Payement.css';

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const Payement = () => {
  return (
    <div className="hd-payment-container">
      <motion.nav
        className="hd-breadcrumb"
        aria-label="breadcrumb"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <Link to="/">Accueil</Link>
        <FiChevronRight />
        <span>Mode de paiement</span>
      </motion.nav>

      <div className="hd-payment-header">
        <span className="hd-payment-eyebrow">Comment payer</span>
        <h1 className="hd-payment-title">Mode de paiement</h1>
      </div>

      <div className="hd-payment-content">
        <motion.div className="hd-payment-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeUp}>
          <h2 className="hd-payment-subtitle"><span className="hd-payment-icon"><FiShoppingBag /></span> Paiement en magasin</h2>
          <ul className="hd-payment-list">
            <li>Espèce</li>
            <li>Chèque (bancaire ou postal)</li>
            <li>TPE (par carte bancaire)</li>
            <li>Pass cadeau</li>
          </ul>
        </motion.div>

        <motion.div className="hd-payment-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeUp}>
          <h2 className="hd-payment-subtitle"><span className="hd-payment-icon"><FiTruck /></span> Paiement à la livraison</h2>
          <ul className="hd-payment-list">
            <li>Espèce</li>
            <li>Chèque (bancaire ou postal)</li>
          </ul>
        </motion.div>

        <motion.div className="hd-payment-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeUp}>
          <h2 className="hd-payment-subtitle"><span className="hd-payment-icon"><FiGlobe /></span> Paiement en ligne</h2>
          <ul className="hd-payment-list">
            <li>Carte bancaire</li>
            <li>Virement</li>
          </ul>
        </motion.div>

        <motion.div className="hd-payment-notice" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.4 }} variants={fadeUp}>
          <div className="hd-payment-notice-icon"><FiAlertTriangle /></div>
          <p>
            <strong>Attention : </strong>
            Les articles commandés et payés par virement bancaire restent réservés jusqu'à ce que le virement soit validé par nos services avec un délai maximum de 48h. Dépassant ce délai aucune livraison ne sera effectuée et la commande sera annulée.
          </p>
        </motion.div>

        <motion.div className="hd-payment-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeUp}>
          <h2 className="hd-payment-subtitle"><span className="hd-payment-icon"><FiMail /></span> Mandat Postal</h2>
          <p>
            Une fois votre commande validée avec ce mode de paiement, votre mandat pourra être émis auprès de votre bureau de poste. Après versement du montant de votre commande (liquide, chèque, CB ou autres) au guichet du bureau de poste, ce dernier nous transmettra la somme. Le délai de réception et de traitement de ce type de transaction est de à 2-4 jours ouvrés.
          </p>
          <div className="hd-payment-notice">
            <div className="hd-payment-notice-icon"><FiAlertTriangle /></div>
            <p>
              <strong>Attention : </strong>
              Les articles commandés et payés par mandat postal restent réservés jusqu'à ce que le paiement soit validé par nos services. Dépassant ce délai aucune livraison ne sera effectuée et la commande sera annulée.
            </p>
          </div>
        </motion.div>

        <motion.div className="hd-payment-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeUp}>
          <h2 className="hd-payment-subtitle"><span className="hd-payment-icon"><PiBankBold /></span> Virement/Versement bancaire</h2>
          <p>Les virements bancaires doivent être adressés :</p>

          <div className="hd-payment-bank-details">
            <div className="hd-payment-bank-card">
              <h3>Banque Attijari</h3>
              <ul>
                <li><strong>Bénéficiaire :</strong> HOME DECO</li>
                <li><strong>Domiciliation :</strong> SOUSSE</li>
                <li><strong>Numéro de compte :</strong> 04115080004598725258</li>
              </ul>
            </div>

            <div className="hd-payment-bank-card">
              <h3>Banque UIB</h3>
              <ul>
                <li><strong>Bénéficiaire :</strong> HOME DECO</li>
                <li><strong>Domiciliation :</strong> CHARGUIA 1</li>
                <li><strong>Numéro de compte :</strong> 12203000003302656855</li>
              </ul>
            </div>
          </div>
        </motion.div>

        <motion.div className="hd-payment-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeUp}>
          <h2 className="hd-payment-subtitle"><span className="hd-payment-icon"><FiCreditCard /></span> Achat par facilité</h2>
          <p>
            Home Deco accorde des facilités de paiement sur 3, 6, 9 et 12 mois :
          </p>
          <ul className="hd-payment-list">
            <li>Paiement par facilité sur 3 mois : sans intérêt.</li>
            <li>Paiement par facilité plus que 3 mois : avec des intérêts*.</li>
          </ul>
          <p className="hd-payment-small-text">
            *Vous trouvez les frais supplémentaires dans le tableau de facilité sous l'image de chaque produit sur le site web.
          </p>
          <p>
            La demande d'achat par facilité se fait sans dossier bancaire, et la réponse vous sera communiquée instantanément sur place. Pour en bénéficier vous devez vous présenter en personne à l'un de nos points de vente avec les documents suivant :
          </p>
          <ul className="hd-payment-list">
            <li>Votre carnet de chèques</li>
            <li>Carte d'identité nationale + une copie</li>
            <li>Relevés ou extraits bancaires des 3 derniers mois avec cachet de la banque</li>
            <li>La dernière fiche de paie avec cachet</li>
          </ul>
          <p>
            L'accord est octroyé après l'étude de la situation professionnelle du client et ses capacités de remboursement.
          </p>
          <div className="hd-payment-contact-box">
            <span className="hd-payment-icon"><FiPhone /></span>
            <p>
              Pour tous renseignements appelez notre service commercial au<br />
              <strong>{process.env.REACT_APP_TEL}</strong>
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Payement;
